import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

export const resetWidget = (data: any) => {
  return HttpService.post(
    `${ApiService.icdc.module.dashboard.getMyLearningConfig}/reset-widget`,
    data
  );
};

export const searchUser = (data: any) => {
  return HttpService.post(
    ApiService.icdc.module.roleManagement.searchUsers,
    data
  );
};
